type TCompanyHarmonicData = {
  logo_url: string;
};

export type TCompanyData = {
  id: number;
  name: string;
  website: string;
  logoUrl: string | null;
  businessModels?: string;
  city?: string;
  angelListWithoutUrl?: string;
  facebookUrl?: string;
  financialStage?: string;
  githubUrl?: string | null;
  headline?: string;
  instagramUrl?: string | null;
  linkedInUrl?: string;
  productHuntUrl?: string | null;
  state?: string | null;
  country: string;
  totalFunding?: number;
  twitterUrl?: string;
  description: string;
  industries?: string;
  harmonic: TCompanyHarmonicData;
  sam?: number;
  som?: number;
  tam?: number;
  stage?: { id: number; name: string };
  tags?: { id: number; name: string }[];
  phone?: string;
  email?: string;
  harmonicTags?: string[];
  emailDomain?: string;
  harmonicInvestors?: {
    harmonicInvestor: {
      id: number;
      name: string;
    };
  }[];
  [key: string]: any;
};

export type TCompanyDetails = {
  hasInnoveraData: boolean;
  hasPitchdeckData: boolean;
  angelListUrl: string | null;
  city: string;
  country: "United States";
  currencyId: number;
  description: string;
  emailDomain: string;
  facebookUrl: string | null;
  foundingDate: string;
  githubUrl: string | null;
  headline: string;
  instagramUrl: string | null;
  linkedInUrl: string | null;
  logoUrl: string | null;
  name: string;
  productHuntUrl: string | null;
  sam: number | null;
  som: number | null;
  state: string;
  tam: number | null;
  totalFunding: number;
  twitterUrl: string | null;
  valuation: number | null;
  website: string;
  companyData: TCompanyData;
  tags: any[];
  [key: string]: any;
};

export type TCompanyComparedDetails = {
  businessModels?: any;
  city: string;
  angelListUrl?: string;
  country: string;
  description: string;
  facebookUrl?: string;
  financialStage?: any;
  foundingDate?: string;
  fundingRoundsCount?: number;
  githubUrl?: string;
  harmonicInvestors?: { name: string; type: string }[];
  harmonicTags?: string[];
  headcount?: number;
  headline: string;
  id: number;
  instagramUrl?: string;
  lastFundingAmount?: number;
  lastFundingDate?: string;
  linkedInUrl?: string;
  logoUrl?: string;
  name: string;
  productHuntUrl?: string;
  state: string;
  totalFunding?: number;
  twitterUrl?: string;
  website: string;
  email?: string;
  hasInnoveraData?: boolean;
  hasPitchdeckData?: boolean;
  industries?: any;
  marketDescription?: any;
  parsedCompetitors?: any[];
  parsingMessage?: any;
  parsingProgress?: number;
  parsingStatus?: string;
  phone?: string;
  sam?: any;
  solutionDescription?: any;
  som?: any;
  stage?: { id: number; name: string };
  tags?: string[];
  tam?: any;
  teamMembers?: { id: number; firstName: string; lastName: string; title?: string }[];
  [key: string]: any;
};

export type TPatent = {
  abstract: string;
  date: string;
  id: string;
  title: string;
  url: string;
};

export type TPatentsData = {
  patents: TPatent[];
  totalCount: number;
};

export enum EDataRoomSection {
  TEAM_DOCUMENTS = "Team Documents",
  CUSTOMERS_AND_PARTNERS = "Customers & Partners",
  SALES_AND_MARKETING = "Sales & Marketing",
  FINANCIALS = "Financials",
  MARKET_AND_COMPETITION = "Market & Competition",
  PRODUCT_AND_TECHNOLOGY = "Product & Technology",
  LEGAL = "Legal",
  OTHER = "Other"
}

export enum EDataStatus {
  processing = "processing",
  done = "done",
  matching_done = "matching_done",
  error = "error",
  parsing = "parsing"
}

export enum EActiveView {
  PROFILE = "Profile",
  DATA_ROOM = "Data Room",
  ANNOTATIONS = "Annotations"
}

export type TMarketLandscapeSectionData = {
  city: string;
  country: string;
  financeStage: string;
  headline: string;
  id: number;
  logoUrl: string;
  name: string;
  state: string;
  totalFunding: number;
  valuation: number;
  website: string;
}[];

export type TProduct = {
  description: string;
  id: number;
  name: string;
  imageUrl: string;
  url: string;
};

export type TProductsData = {
  status: string;
  products: TProduct[];
  urls: string[];
  summary: string | null;
};

export enum EAccessDataStatus {
  FULL_DATA = "full_data",
  NO_ACCESS = "no_access",
  PENDING_REQUEST = "pending_request",
  NO_FOUNDER = "no_founder",
  PROFILE_DATA = "profile_data"
}

export enum EInvestorAccess {
  FULL = "Full",
  PROFILE = "Profile"
}

export enum EInvestorAccessStatus {
  APPROVED = "approved",
  PENDING = "pending"
}
